var _filter, _filter2, _filter3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 284,
    viewBox: "0 0 417 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4533_8932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 31,
    width: 389,
    height: 229,
    fill: "url(#paint0_diamond_4533_8932)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4533_8932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.5,
    y: 24,
    width: 333,
    height: 229,
    fill: "url(#paint1_diamond_4533_8932)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M218.3 172.41L205.87 153.6L200.15 145.57L177.05 114H198.17L210.16 131.93L216.43 140.51L239.2 172.41H218.3ZM176.5 172.41L200.04 139.63L209.5 150.96L197.29 172.41H176.5ZM215.11 147L205.76 135.78L217.31 114H238.1L215.11 147Z",
    fill: "url(#paint2_linear_4533_8932)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.995 145.733C199.995 173.299 177.831 195.639 150.5 195.639C123.169 195.639 101.005 173.299 101.005 145.733C101.005 118.167 123.169 95.8273 150.5 95.8273C177.831 95.8273 199.995 118.167 199.995 145.733Z",
    fill: "url(#paint3_linear_4533_8932)",
    stroke: "#BEA1FF",
    style: {
      stroke: "#BEA1FF",
      stroke: "color(display-p3 0.7451 0.6314 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.0101
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4533_8932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.48 163.835C126.207 161.247 124.584 158.356 123.559 155.099C122.512 151.774 122.275 148.391 122.701 144.972C123.203 140.938 124.7 137.266 127.14 133.993C127.152 133.978 127.164 133.963 127.178 133.949C128.11 133.077 128.28 132.083 128.081 130.799C127.626 127.863 127.438 124.891 127.691 121.914C127.726 121.494 127.818 121.076 127.917 120.665C128.084 119.977 128.449 119.705 129.103 119.961C130.319 120.438 131.569 120.899 132.667 121.585C134.527 122.748 136.272 124.093 138.089 125.328C138.315 125.482 138.719 125.538 138.981 125.454C141.547 124.634 144.173 124.273 146.861 124.333C149.154 124.383 151.399 124.729 153.572 125.478C153.992 125.623 154.28 125.535 154.62 125.259C156.961 123.354 159.432 121.644 162.189 120.383C162.59 120.2 163.02 120.071 163.447 119.959C164.178 119.767 164.578 119.961 164.661 120.691C164.831 122.199 165.02 123.721 164.99 125.233C164.96 126.768 164.79 128.322 164.482 129.827C163.516 134.54 161.611 138.805 158.164 142.275C157.707 142.735 157.611 142.721 157.307 142.14C154.679 137.121 148.612 134.486 143.115 136.005C139.12 137.11 136.303 139.575 134.703 143.406C132.078 149.694 135.181 157.103 141.563 159.656C144.245 160.73 146.957 160.844 149.744 160.183C152.493 159.531 154.654 157.918 156.668 156.051C158.491 154.362 160.181 152.512 162.391 151.292C164.942 149.883 167.624 149.117 170.565 149.708C173.756 150.348 176.011 152.216 177.344 155.124C177.89 156.316 178.12 157.652 178.491 158.924C178.51 158.992 178.493 159.07 178.493 159.255C177.959 159.105 177.474 158.969 176.99 158.832C173.439 157.83 170.245 158.595 167.449 160.912C166.086 162.04 164.885 163.362 163.608 164.594C161.053 167.06 158.169 169.033 154.839 170.298C150.429 171.974 145.903 172.298 141.286 171.311C136.21 170.227 131.966 167.719 128.48 163.835Z",
    fill: "url(#paint4_linear_4533_8932)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4533_8932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315 143.5C315 170.562 293.062 192.5 266 192.5C238.938 192.5 217 170.562 217 143.5C217 116.438 238.938 94.5 266 94.5C293.062 94.5 315 116.438 315 143.5Z",
    fill: "url(#paint5_linear_4533_8932)",
    stroke: "#88C5FD",
    style: {
      stroke: "#88C5FD",
      stroke: "color(display-p3 0.5337 0.7722 0.9923)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.633 142.973C253.209 136.622 262.928 132.436 267.792 130.413C281.677 124.637 284.562 123.634 286.443 123.601C286.857 123.594 287.781 123.696 288.381 124.182C288.886 124.593 289.026 125.147 289.092 125.536C289.159 125.925 289.242 126.812 289.176 127.505C288.423 135.411 285.167 154.597 283.511 163.452C282.81 167.199 281.43 168.455 280.094 168.578C277.19 168.845 274.986 166.659 272.173 164.816C267.773 161.931 265.287 160.136 261.015 157.321C256.078 154.067 259.279 152.279 262.092 149.357C262.828 148.593 275.621 136.956 275.869 135.901C275.9 135.769 275.929 135.276 275.636 135.017C275.344 134.757 274.913 134.846 274.601 134.916C274.16 135.016 267.13 139.663 253.511 148.856C251.515 150.226 249.708 150.894 248.089 150.859C246.303 150.821 242.869 149.85 240.316 149.02C237.185 148.002 234.696 147.464 234.913 145.735C235.026 144.835 236.266 143.914 238.633 142.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4533_8932",
    x: 43.5,
    y: 7,
    width: 437,
    height: 277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_4533_8932"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4533_8932",
    x: -63.5,
    y: 0,
    width: 381,
    height: 277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_4533_8932"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4533_8932",
    x: 93.9,
    y: 110.333,
    width: 113.2,
    height: 109.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.0667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4533_8932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4533_8932",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_4533_8932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.949 143.064) rotate(152.075) scale(185.416 190.669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BACEE",
    style: {
      stopColor: "#2BACEE",
      stopColor: "color(display-p3 0.1686 0.6745 0.9333)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040208",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_4533_8932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.237 136.064) rotate(138.607) scale(160.115 190.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C35E0",
    style: {
      stopColor: "#6C35E0",
      stopColor: "color(display-p3 0.4217 0.2087 0.8771)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040208",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4533_8932",
    x1: 176.5,
    y1: 142,
    x2: 236.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A2FF",
    style: {
      stopColor: "#C0A2FF",
      stopColor: "color(display-p3 0.7529 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BABEE",
    style: {
      stopColor: "#2BABEE",
      stopColor: "color(display-p3 0.1686 0.6706 0.9333)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4533_8932",
    x1: 150.5,
    y1: 95.3223,
    x2: 150.5,
    y2: 196.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160E26",
    style: {
      stopColor: "#160E26",
      stopColor: "color(display-p3 0.0856 0.0559 0.1503)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090510",
    style: {
      stopColor: "#090510",
      stopColor: "color(display-p3 0.0334 0.0208 0.0610)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4533_8932",
    x1: 161.881,
    y1: 119.866,
    x2: 161.881,
    y2: 170.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A377FF",
    style: {
      stopColor: "#A377FF",
      stopColor: "color(display-p3 0.6378 0.4686 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48278F",
    style: {
      stopColor: "#48278F",
      stopColor: "color(display-p3 0.2815 0.1511 0.5608)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4533_8932",
    x1: 5216,
    y1: 93.5,
    x2: 5216,
    y2: 10019.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE",
    style: {
      stopColor: "#2AABEE",
      stopColor: "color(display-p3 0.1647 0.6706 0.9333)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9",
    style: {
      stopColor: "#229ED9",
      stopColor: "color(display-p3 0.1333 0.6196 0.8510)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4533_8932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(216 93.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramSwitch);
export default __webpack_public_path__ + "static/media/telegram-switch.3975480c599e0d38221dea8a1f85725f.svg";
export { ForwardRef as ReactComponent };